var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 79,
    viewBox: "0 0 68 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 57.9838V32C65.75 17.8588 65.75 10.7862 61.355 6.395C56.96 2.00375 49.8912 2 35.75 2H32C17.8588 2 10.7862 2 6.395 6.395C2.00375 10.79 2 17.8588 2 32V67.625",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 58.25H11.375C8.8886 58.25 6.50403 59.2377 4.74587 60.9959C2.98772 62.754 2 65.1386 2 67.625C2 70.1114 2.98772 72.496 4.74587 74.2541C6.50403 76.0123 8.8886 77 11.375 77H65.75",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.75 77.0005C63.2636 77.0005 60.879 76.0128 59.1209 74.2547C57.3627 72.4965 56.375 70.112 56.375 67.6255C56.375 65.1391 57.3627 62.7546 59.1209 60.9964C60.879 59.2383 63.2636 58.2505 65.75 58.2505M35.03 39.5005L29.5513 22.5468C29.3616 22.0124 29.0085 21.5513 28.542 21.2289C28.0755 20.9065 27.5194 20.7391 26.9525 20.7505C26.3856 20.7391 25.8295 20.9065 25.363 21.2289C24.8965 21.5513 24.5434 22.0124 24.3538 22.5468L18.875 39.5005M45.125 20.7505V39.5005M20.8925 33.8755H33.0088",
    stroke: "#363636",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.2879945587a85e784a7e1d77f6cb8660.svg";
export { ForwardRef as ReactComponent };